import { CollectionCreateIcon } from "../../../assets/img/CollectionCreateIcon";
import { SingleCreateIcon } from "../../../assets/img/SingleCreateIcon";
import { sliderArrowRight } from "../../../assets/img/sliderArrowRight";
import { CreateDropdownButton, CreateDropdownWrapper } from "./CreateDropdown.styled";
import { toggleCreateCollectionModal } from "../../../store/app/appSlice";
import { useDispatch } from "react-redux";

export const CreateDropdown = ({ styles, closeMenu }) => {
  const dispatch = useDispatch();
  return (
    <CreateDropdownWrapper style={styles}>
      <CreateDropdownButton to='/create-nft' onClick={() => closeMenu()}>
        <div>{SingleCreateIcon()} &nbsp;Single NFT</div> {sliderArrowRight()}
      </CreateDropdownButton>
      <CreateDropdownButton to onClick={() => dispatch(toggleCreateCollectionModal())}>
        <div>{CollectionCreateIcon()} &nbsp;Collection</div>
        {sliderArrowRight()}
      </CreateDropdownButton>
    </CreateDropdownWrapper>
  );
};
